// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"917f5796","137":"e2ea0649","152":"8406f3a7","205":"0f234b73","467":"66b99b7f","984":"35c48d04"}[chunkId] + ".chunk.css";
};